import React, { FC, useCallback, useContext } from 'react'
import styles from '../../styles'
import { makeStyles } from 'tss-react/mui'
import { GRIS } from '../../theme'
import { Grid } from '@mui/material'
import Button from '../button/Button'
import { FormattedMessage } from 'react-intl'
import BlocOffer from './components/BlocOffer'
import BlocClient from './components/BlocClient'
import { buttonSize } from '../button/enums/buttonEnum'
import { SelectionPaneContext } from './components/SelectionPaneContext'
import { useNavigate } from 'react-router'
import links from '../../enums/linksEnum'
import { DEFAULT_OFFER_FILTERS } from '../../modules/rechercheOffre/utils/rechercheOffreConstants'

const SelectionPane: FC = () => {
	const { classes, cx } = useStyles()
	const { resetSelection } = useContext(SelectionPaneContext)
	const navigate = useNavigate()

	const selectionPaneContainer = cx(
		classes.selectionPaneContainer
	)

	const reset = useCallback(() => {
		resetSelection()
		navigate({ pathname: links.RECHERCHE_OFFRE, search: DEFAULT_OFFER_FILTERS })
	}, [resetSelection, navigate])

	return (
		<Grid container className={selectionPaneContainer}>
			<Grid container spacing="20px">
				<Grid container item>
					<Button
						background="backgroundAccessibility"
						color="colorWhite"
						textStyle="text4"
						size={buttonSize.small}
						onClick={reset}
						buttonStyle={classes.buttonStyle}
						fullWidth
					>
						<FormattedMessage
							id="selectionPanel.btn"
							defaultMessage="Nouvelle recherche"
							description="Bouton pour faire une nouvelle recherche"
						/>
					</Button>
				</Grid>
				<BlocOffer />
				<BlocClient />
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	selectionPaneContainer: {
		backgroundColor: GRIS,
		height: '100%',
		boxShadow: '0px 4px 4px 0px #00000040 inset',
		padding: '20px 10px',
		flexDirection: 'column'
	},
	buttonStyle: {
		borderRadius: 25
	}
}))

export default SelectionPane